<template>
  <!--  页面使用   <OverflowTooltip :tip="ops.name" /> -->
  <el-tooltip
    popper-class="desc-popper"
    effect="light"
    :visible-arrow="false"
    placement="top"
    :disabled="!showTooltip"
  >
    <!-- tooltip 内容 -->
    <div slot="content">
      <slot name="tooltip">
        {{ tip }}
      </slot>
    </div>

    <!-- 文本本体 -->
    <div
      ref="text"
      v-resize="checkOverflow"
      :class="['ellipsis', lineClamp > 1 ? 'multi' : 'single']"
      :style="textStyle"
    >
      <slot>
        {{ tip }}
      </slot>
    </div>
  </el-tooltip>
</template>

<script>
export default {
  name: "OverflowTooltip",
  props: {
    tip: {
      type: String,
      default: "",
    },
    // 最大宽度（单行必传，多行强烈建议）
    maxWidth: {
      type: [Number, String],
      default: null,
    },
    maxHeight: {
      type: [Number, String],
      default: null,
    },
    // 显示行数
    lineClamp: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      showTooltip: false,
    };
  },
  computed: {
    textStyle() {
      const style = {
        overflow: "hidden",
      };

      if (this.maxWidth !== null) {
        style.width =
          typeof this.maxWidth === "number"
            ? this.maxWidth + "px"
            : this.maxWidth;
      }
      if (this.maxHeight !== null) {
        style.height =
          typeof this.maxHeight === "number"
            ? this.maxHeight + "px"
            : this.maxHeight;
      }

      if (this.lineClamp > 1) {
        style.WebkitLineClamp = this.lineClamp;
      }

      return style;
    },
  },
  watch: {
    tip() {
      this.$nextTick(this.checkOverflow);
    },
    lineClamp() {
      this.$nextTick(this.checkOverflow);
    },
    maxWidth() {
      this.$nextTick(this.checkOverflow);
    },
    maxHeight() {
      this.$nextTick(this.checkOverflow);
    },
  },
  mounted() {
    this.checkOverflow();
  },
  methods: {
    checkOverflow() {
      const el = this.$refs.text;
      if (!el) return;

      if (this.lineClamp === 1) {
        this.showTooltip = el.scrollWidth > el.clientWidth;
      } else {
        this.showTooltip = el.scrollHeight > el.clientHeight;
      }
    },
  },
  directives: {
    resize: {
      inserted(el, binding) {
        if (typeof ResizeObserver === "undefined") return;

        const ro = new ResizeObserver(() => {
          binding.value();
        });

        ro.observe(el);
        el.__ro__ = ro;
      },
      unbind(el) {
        el.__ro__ && el.__ro__.disconnect();
      },
    },
  },
};
</script>

<style scoped>
.ellipsis {
  word-break: break-all;
  font-size: inherit;
}

.single {
  font-family: inherit;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.multi {
  font-family: inherit;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
</style>
